"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.messages = void 0;
/*eslint-disable*/const messages = {
  Apply: "Appliquer",
  Clear: "Effacer",
  "Date picker open, choose a date": "Une fois le sélecteur de dates ouvert, sélectionner une date",
  "Date range picker open, select a date range": "Une fois le sélecteur de plages de dates ouvert, sélectionner une plage de dates",
  "End Date": "Date de fin",
  "Please enter a valid date ({format})": ["Veuillez saisir une date valide (", ["format"], ")"],
  "Please select a date after {minDate}": ["Veuillez sélectionner une date antérieure au ", ["minDate"]],
  "Please select a date before {maxDate}": ["Veuillez sélectionner une date postérieure au ", ["maxDate"]],
  "Show next month": "Afficher le mois suivant",
  "Show previous month": "Afficher le mois précédent",
  "Start Date": "Date de début",
  "The selected date is disabled": "La date sélectionnée est désactivée",
  "The selected date is unavailable. Please select another.": "La date sélectionnée n’est pas disponible. Veuillez en sélectionner une autre.",
  Today: "Aujourd’hui",
  "Today, {dateStr}": ["Aujourd’hui, ", ["dateStr"]],
  "date picker": "sélecteur de dates",
  "start date selected": "date de début sélectionnée",
  to: "à",
  "{dateStr}, select end date": [["dateStr"], ", sélectionner la date de fin"],
  "{dateStr}, select start date": [["dateStr"], ", sélectionner la date de début"],
  "{startDate} to {endDate}, choose apply to confirm, or cancel": ["du ", ["startDate"], " au ", ["endDate"], ", sélectionner Appliquer pour confirmer ou Annuler"]
};
exports.messages = messages;
//# sourceMappingURL=messages.js.map